module.exports = __webpack_public_path__ + "static/img/weijiemeng.f4177139.png";